import { create } from 'zustand'

type LoaderState = {
  isLoading: boolean
  loadingMessage: string
}

type Actions = {
  openLoader: (message: string) => void
  closeLoader: () => void
}
const defaultValues: LoaderState = {
  isLoading: false,
  loadingMessage: ''
}

const useBackdropLoaderStore = create<LoaderState & Actions>(set => ({
  ...defaultValues,
  openLoader: message => set(() => ({ loadingMessage: message, isLoading: true })),
  closeLoader: () => set(() => ({ loadingMessage: '', isLoading: false }))
}))

export default useBackdropLoaderStore
